var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.79289 1.79289C2.98043 1.60536 3.23478 1.5 3.5 1.5H9.5C9.63261 1.5 9.75979 1.55268 9.85355 1.64645L13.3536 5.14645C13.4473 5.24021 13.5 5.36739 13.5 5.5V8C13.5 8.27614 13.2761 8.5 13 8.5C12.7239 8.5 12.5 8.27614 12.5 8V5.70711L9.29289 2.5L3.5 2.5L3.5 8C3.5 8.27614 3.27614 8.5 3 8.5C2.72386 8.5 2.5 8.27614 2.5 8V2.5C2.5 2.23478 2.60536 1.98043 2.79289 1.79289Z",
    fill: "#FF6D0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 1.5C9.77614 1.5 10 1.72386 10 2V5H13C13.2761 5 13.5 5.22386 13.5 5.5C13.5 5.77614 13.2761 6 13 6H9.5C9.22386 6 9 5.77614 9 5.5V2C9 1.72386 9.22386 1.5 9.5 1.5Z",
    fill: "#FF6D0A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 10.5C2.5 10.2239 2.72386 10 3 10H4C4.39783 10 4.77936 10.158 5.06066 10.4393C5.34196 10.7206 5.5 11.1022 5.5 11.5C5.5 11.8978 5.34196 12.2794 5.06066 12.5607C4.77936 12.842 4.39783 13 4 13H3.5V13.5C3.5 13.7761 3.27614 14 3 14C2.72386 14 2.5 13.7761 2.5 13.5V10.5ZM3.5 12H4C4.13261 12 4.25978 11.9473 4.35355 11.8536C4.44732 11.7598 4.5 11.6326 4.5 11.5C4.5 11.3674 4.44732 11.2402 4.35355 11.1464C4.25978 11.0527 4.13261 11 4 11H3.5V12Z",
    fill: "#FF6D0A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 10.5C11.25 10.2239 11.4739 10 11.75 10H13.5C13.7761 10 14 10.2239 14 10.5C14 10.7761 13.7761 11 13.5 11H12.25V13.5C12.25 13.7761 12.0261 14 11.75 14C11.4739 14 11.25 13.7761 11.25 13.5V10.5Z",
    fill: "#FF6D0A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 12.25C11.25 11.9739 11.4739 11.75 11.75 11.75H13.25C13.5261 11.75 13.75 11.9739 13.75 12.25C13.75 12.5261 13.5261 12.75 13.25 12.75H11.75C11.4739 12.75 11.25 12.5261 11.25 12.25Z",
    fill: "#FF6D0A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.625 10.5C6.625 10.2239 6.84886 10 7.125 10H8C8.53043 10 9.03914 10.2107 9.41421 10.5858C9.78929 10.9609 10 11.4696 10 12C10 12.5304 9.78929 13.0391 9.41421 13.4142C9.03914 13.7893 8.53043 14 8 14H7.125C6.84886 14 6.625 13.7761 6.625 13.5V10.5ZM7.625 11V13H8C8.26522 13 8.51957 12.8946 8.70711 12.7071C8.89464 12.5196 9 12.2652 9 12C9 11.7348 8.89464 11.4804 8.70711 11.2929C8.51957 11.1054 8.26522 11 8 11H7.625Z",
    fill: "#FF6D0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.8fe7dd885fcb1525ddfb077035dfa1a1.svg";
export { ForwardRef as ReactComponent };